import PartnersApi from 'entities/partners/api';

import { useQuery } from '../useQuery';

export const usePartners = (
  opts: {
    status?: string | string[];
    search?: string;
    countryCode?: string;
    acceptsDonations?: boolean;
  } = {},
  skip = false
) =>
  useQuery(
    async () => {
      const response = await PartnersApi.fetchRaw(opts).toPromise();
      return response.partners;
    },
    [],
    undefined,
    skip
  );
